var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestAngel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.427,
    height: 163.86,
    viewBox: "0 0 162.427 163.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 162.427,
    height: 163.86,
    fill: "#c4e7f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "test-angel",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M21.125,27.483a13.1,13.1,0,1,0-13.1-13.1,13.1,13.1,0,0,0,13.1,13.1",
    transform: "translate(60.818 9.78)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M58.6,7.951C49.893,4.656,36.844,4.785,36.586,4.785c0,0-13.238-.163-22.032,3.166-9.12,3.449-8.562,8.828-8.562,8.828V68.754a5.186,5.186,0,0,0,10.373,0v-43.8a1.566,1.566,0,0,1,3.132,0v95.782a6.859,6.859,0,1,0,13.719,0V67.587a11.64,11.64,0,0,1,3.337-.558,11.479,11.479,0,0,1,3.389.566v53.15a6.855,6.855,0,1,0,13.71,0V24.956a1.57,1.57,0,0,1,3.14,0v43.8a5.182,5.182,0,1,0,10.364,0V16.779S67.713,11.4,58.6,7.951M49.112,24.158a7.129,7.129,0,0,1-.909,1.913c-.2.309-.412.6-.626.9-.172.223-.343.446-.523.661-.24.292-.5.575-.755.867-.232.266-.472.523-.712.789l-.335.335c-.146.154-.292.309-.446.455-.275.266-.549.532-.832.8l-.6.549c-.266.24-.523.489-.8.721-.42.369-.841.721-1.27,1.072h-.06c-.206-.18-.412-.352-.618-.532-.232-.206-.463-.4-.686-.609-.283-.249-.566-.48-.832-.738-.558-.523-1.115-1.047-1.656-1.587-.438-.438-.849-.9-1.27-1.356a15.473,15.473,0,0,1-1.261-1.544c-.257-.352-.506-.712-.729-1.09a10.326,10.326,0,0,1-.5-.969,3.409,3.409,0,0,1-.326-1.09,4.126,4.126,0,0,1,.249-1.9,3.964,3.964,0,0,1,.746-1.27,6.138,6.138,0,0,1,.532-.523,3.519,3.519,0,0,1,.489-.395A4.587,4.587,0,0,1,36.938,19a4.358,4.358,0,0,1,3.32.7,4.32,4.32,0,0,1,.969.927c.043.051.069.06.12,0a4.8,4.8,0,0,1,1.553-1.27,3.343,3.343,0,0,1,1.064-.335c.275-.034.541-.086.806-.094a3.868,3.868,0,0,1,.944.086,4.125,4.125,0,0,1,1.235.463,4.529,4.529,0,0,1,1,.755,4,4,0,0,1,.695.909,4.668,4.668,0,0,1,.472,1.2,3.694,3.694,0,0,1-.009,1.81",
    transform: "translate(45.365 36.262)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M32.337,20.175a3.674,3.674,0,1,0,1.63-7.164L9.756,7.494v-1l-7.6-1.733L.07,13.92l7.636,1.733.48-.978ZM18.078,11.707l-.626,2.754L8.444,12.41,9.07,9.656Z",
    transform: "translate(0.531 36.127)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M33.64,14.188A3.675,3.675,0,0,0,32.722,6.9l-24.64,3.1-.343-.935L0,10.036l1.175,9.309,7.764-.978.12-1.09Zm-16.3-3.08.352,2.805-9.163,1.15-.352-2.805Z",
    transform: "translate(0 52.04)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M12.163,7.82l.369-1.038L5.952,2.535.864,10.428l6.555,4.221.712-.695L29,27.416a3.671,3.671,0,1,0,3.981-6.169ZM9.195,11.955,10.73,9.579l7.756,5.01-1.527,2.377Z",
    transform: "translate(6.549 19.217)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M33.533,14.873A3.676,3.676,0,0,0,30.17,8.335L8.086,19.677l-.643-.764L.5,22.474l4.29,8.356,6.967-3.578-.266-1.064Zm-16.37,2.685,1.287,2.514L10.24,24.293l-1.3-2.514Z",
    transform: "translate(3.805 60.141)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M13.857,7.956l.7-.849L9.824.869,2.343,6.54l4.719,6.22.9-.412L22.968,32.133a3.677,3.677,0,0,0,5.86-4.444Zm-4.2,2.874,2.256-1.707,5.577,7.361-2.256,1.707Z",
    transform: "translate(17.759 6.589)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M30.329,14.929a3.676,3.676,0,0,0-5.4-4.993L8.057,28.141l-.867-.5-5.3,5.723,6.889,6.383L14.1,34l-.609-.909ZM15.864,23.045l2.076,1.922-6.28,6.778L9.584,29.823Z",
    transform: "translate(14.31 66.373)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M14.822,8.039l.944-.558L13.458,0,4.492,2.771l2.3,7.456,1-.077,7.327,23.722A3.677,3.677,0,0,0,22.14,31.7ZM9.889,9.3l2.7-.832,2.728,8.82-2.7.841Z",
    transform: "translate(34.047 0.003)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M43.22,14.709l.48.978,7.636-1.733L49.251,4.8l-7.6,1.733v1L17.438,13.045a3.674,3.674,0,1,0,1.63,7.164ZM42.336,9.69l.626,2.754-9.008,2.05-.626-2.754Z",
    transform: "translate(110.482 36.384)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M42.43,17.317l.12,1.09,7.764.978,1.175-9.317L43.751,9.1l-.343.935L18.767,6.927a3.675,3.675,0,0,0-.918,7.293Zm.884-5.019L42.962,15.1,33.8,13.953l.352-2.805Z",
    transform: "translate(110.937 52.292)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M15.8,21.273a3.677,3.677,0,0,0,3.989,6.177L40.66,13.989l.712.695,6.555-4.23L42.839,2.57l-6.58,4.247.36,1.03Zm16.026-4.281L30.3,14.616l7.764-5.01L39.6,11.982Z",
    transform: "translate(107.088 19.482)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M38.38,26.219l-.266,1.064,6.967,3.578,4.29-8.348-6.941-3.56-.635.755L19.7,8.374a3.674,3.674,0,1,0-3.355,6.538Zm2.548-4.41-1.3,2.514-8.211-4.213,1.287-2.522Z",
    transform: "translate(108.75 60.393)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M14.162,27.731a3.671,3.671,0,1,0,5.851,4.436L35.019,12.382l.909.412,4.71-6.22L33.157.9,28.43,7.149l.7.841Zm13.6-9.506L25.5,16.518l5.585-7.361,2.248,1.707Z",
    transform: "translate(101.678 6.847)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M31.431,33.132l-.609.909,5.319,5.74L43.031,33.4l-5.3-5.714-.867.5L19.986,9.967a3.676,3.676,0,0,0-5.4,4.993Zm3.9-3.277-2.076,1.922-6.28-6.769,2.076-1.93Z",
    transform: "translate(103.19 66.633)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M12.529,31.735a3.677,3.677,0,0,0,7.027,2.171l7.327-23.731,1,.077,2.3-7.447L21.211.034,18.895,7.515l.944.558Zm9.523-13.581-2.7-.832,2.728-8.828,2.7.832Z",
    transform: "translate(93.711 0.26)",
    fill: "#c4e7f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestAngel);
export default __webpack_public_path__ + "static/media/test-angel.3e6279d7b28a65f67ad1038874c9c187.svg";
export { ForwardRef as ReactComponent };